import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import IconButton from '@mui/material/IconButton'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import { HISTORY_RETURN_PARAM_KEY, ROUTE_SEGMENTS } from '@/constants/general'
import YearlyFeeCollectionDiscountDetail from '@/components/yearly-fee-collection/discounts/detail'
import Breadcrumbs from '@/components/breadcrumbs'

function YearlyFeeCollectionDiscountDetailView() {

    const title = 'Detail slevy'

    const { discountId, year } = useParams()

    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const historyReturn = params.get(HISTORY_RETURN_PARAM_KEY)

    const navigate = useNavigate()

    const link = `/${ROUTE_SEGMENTS.base}/${ROUTE_SEGMENTS.municipalityManagement}/${ROUTE_SEGMENTS.yearlyFeeCollection
        }/${year}/${ROUTE_SEGMENTS.yearlyFeeCollectionDiscounts}`

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper noPadding>
                <Box px={2.5} pt={2.5}>
                    <Breadcrumbs />
                </Box>
                <Box px={2.5} pt={1} pb={2} display="flex" alignItems="center" gap={1}>
                    <IconButton
                        aria-label="close"
                        size="small"
                        color="terciary"
                        onClick={historyReturn === 'true' ?
                            () => navigate(-1) :
                            () => navigate(link)}
                    >
                        <ArrowBackRoundedIcon />
                    </IconButton>
                    <Typography variant="h3" component="h1">
                        {title}
                    </Typography>
                </Box>
                <Box px={2.5}>
                    <Box sx={{
                        maxWidth: 'sm',
                    }}>
                        <YearlyFeeCollectionDiscountDetail discountId={Number(discountId)} />
                    </Box>
                </Box>
            </CustomPaper>
        </>
    )
}

export default YearlyFeeCollectionDiscountDetailView
